// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
// iview
import ViewUI from 'view-design';
// import style
import 'view-design/dist/styles/iview.css';
import Cookies from 'js-cookie';
Vue.config.productionTip = false;
Vue.use(ViewUI);
//Vue-Meta 网页SEO
import VueMeta from 'vue-meta'
Vue.use(VueMeta);

// @description 生产环境关掉提示
Vue.config.productionTip = false;

//解决tbale加载慢
import UmyUi from 'umy-ui'
import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
Vue.use(UmyUi);

//实现拖拽
import VueDND from 'awe-dnd'
Vue.use(VueDND)


//vue的ajax
import axios from 'axios'
import  VueAxios from 'vue-axios'
Vue.use(VueAxios,axios);
axios.defaults.timeout = 30000;
// Axios的全局配置
// axios.defaults.baseURL = 'http://26.26.26.1:82/quant'; // 设置基础URL，这是我自己电脑本机的IP地址

// axios.defaults.baseURL = 'http://127.0.0.1:82/quant'; // 设置基础URL
axios.defaults.baseURL = '/quant'; // 设置基础URL
// axios.defaults.baseURL = base.base

// axios.defaults.baseURL = 'http://mm.valiam001.cn:82/quant'; // 设置基础URL

// axios.defaults.baseURL = 'http://192.168.50.232:5000/quant'; // 设置基础URL
axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('token'); // 添加默认授权头，例如token
axios.defaults.withCredentials = true; // 允许跨站点请求时携带凭证（cookies）


// 将api挂载到vue的原型上
import api from './api'
Vue.prototype.$api = api;

//复制
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

// import Mseeage from './api/message.vue'
// Vue.component('Mseeage', Mseeage) //注册Mseeage组件为全局组件

//加载用户主题
if( !localStorage.getItem("themeValue") ){
  localStorage.setItem("themeValue","dark");
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})





// WEBPACK FOOTER //
// ./src/main.js